import React, { useEffect } from 'react'
import * as Cookies from 'js-cookie'

export const CapacitorBrowserCheck = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return false
    const urlParams = new URLSearchParams(window.location.search)
    const hasQueryString = urlParams.get('origin') === 'capacitor'

    if (hasQueryString) {
      Cookies.set('is_from_capacitor_browser', 'true')
    }
  }, [])

  return <div />
}
